import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { AuditLogService } from '../../../../services/audit-log.service';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';  // 👈 import this
import { CreateView } from '../../global/create-view/create-view';
import { UpdateView } from '../../global/update-view/update-view';
import { TimezonePipe } from '../../../../pipes/timezone.pipe';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-booking-view',
  standalone: true,
  imports: [CommonModule, NgbNavModule, CreateView, UpdateView, TimezonePipe, FormsModule],
  templateUrl: './booking-view.html',
  styleUrls: ['./booking-view.scss']
})
export class BookingView implements OnInit {

  bookingId: any;
  logAction: string | null = null;
  logData: any;           // incoming array
  groupedLogs: { [key: string]: any[] } = {}; // grouped result
  isLoading: boolean = false;
  activeTab: number = 1;
  bookingCreate: any;
  bookingUpdates: any[] = []; // <-- make this an array

  constructor(private route: ActivatedRoute, private auditLogService: AuditLogService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.bookingId = params['id'];
      // this.logAction = params['action'];
      // console.log('Booking ID:', this.bookingId);
      // console.log('Log Action:', this.logAction);

      if (this.bookingId) {
        this.fetchBookingLogs(this.bookingId);
      }
    });

  }

  async fetchBookingLogs(bookingId: string): Promise<void> {
    this.isLoading = true; // Show loader
    try {
      const response: any = await firstValueFrom(
        this.auditLogService.searchBookingLogs(bookingId)
      );
      // make sure to pull the actual array
      this.logData = response?.data || [];
      let bookingCreateData: any;
      this.logData.forEach((log: any) => {
        if (log.action === 'CREATE') {
          bookingCreateData = log.new_fields;

          // normalize arr1
          this.bookingCreate = this.normalizeJson(JSON.parse(log.new_fields.booking_request.request_log));

          // add fields from arr2
          this.bookingCreate.start_time = bookingCreateData?.start_time;
          if (bookingCreateData.booking_line_items[0].information.file) {
            this.bookingCreate.booking.option.attachement_link = bookingCreateData.booking_line_items[0].information.file;
          }
        }
        else if (log.action === 'UPDATE') {
          this.bookingUpdates.push(log); // <-- append instead of overwrite
        }
      });
      this.groupedLogs = this.groupBy(this.logData, 'object_id');
      // Sort UPDATE logs by date/time and add version numbers
      Object.values(this.groupedLogs).forEach((logs: any[]) => {
        // Sort logs: UPDATE by updated_at desc, CREATE by created_at desc
        logs.sort((a, b) => {
          const aDate = a.action === 'UPDATE' ? new Date(a.updated_at) : new Date(a.created_at);
          const bDate = b.action === 'UPDATE' ? new Date(b.updated_at) : new Date(b.created_at);
          return bDate.getTime() - aDate.getTime();
        });
        // Add version numbers for UPDATE logs
        let version = 1;
        logs.forEach(log => {
          if (log.action === 'UPDATE') {
            log.version = version++;
          }
          if (log._collapsed === undefined) {
            log._collapsed = false;
          }
        });
      });
      // console.log('Search results:', response);
    } catch (error) {
      console.error('Error during search:', error);
    } finally {
      this.isLoading = false; // Hide loader
    }
  }

  private normalizeJson(data: any): any {
    const grouped: any = {};

    Object.entries(data).forEach(([rawKey, valueArray]) => {
      const keys = rawKey.replace(/\]/g, '').split('[');
      const value = Array.isArray(valueArray) ? valueArray[0] ?? '' : valueArray;

      let pointer = grouped;

      keys.forEach((k, idx) => {
        const safeKey = k; // keep original, no numeric index keys

        if (idx === keys.length - 1) {
          pointer[safeKey] = value;
        } else {
          if (!pointer[safeKey]) pointer[safeKey] = {};
          pointer = pointer[safeKey];
        }
      });
    });

    return grouped;
  }




  // utility to group array of objects by given key
  private groupBy(array: any[], key: string): { [key: string]: any[] } {
    return array.reduce((result, current) => {
      const groupKey = current[key];
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      result[groupKey].push(current);
      return result;
    }, {} as { [key: string]: any[] });
  }
  onSearch() {
    this.fetchBookingLogs(this.bookingId.trim());
  }

  // inside BookingView

  // parseQueryDict(raw: string): any {
  //   if (!raw) return null;

  //   let jsonString = raw.trim();

  //   // Case 1: If wrapped in <QueryDict: ...>
  //   if (jsonString.startsWith("<QueryDict:")) {
  //     const match = jsonString.match(/<QueryDict:\s*(\{.*\})>/s);
  //     if (match) jsonString = match[1];
  //   }

  //   // Replace Python-style with JS/JSON
  //   jsonString = jsonString
  //     .replace(/\bFalse\b/g, "false")
  //     .replace(/\bTrue\b/g, "true")
  //     .replace(/\bNone\b/g, "null")
  //     .replace(/'/g, '"');

  //   // 🔹 Fix bad values
  //   // Remove trailing commas inside arrays/strings like "10,2520,"
  //   jsonString = jsonString.replace(/,+"\]/g, '"]');  
  //   jsonString = jsonString.replace(/,"]+/g, '"]');  

  //   // Fix ARTS|"system"" → ARTS|\"system\"
  //   jsonString = jsonString.replace(/\|"([^"]+)""/g, '|"$1"');

  //   try {
  //     return JSON.parse(jsonString);
  //   } catch (e) {
  //     console.error("❌ Failed to parse request_log:", e, "\nRaw:", raw, "\nFixed:", jsonString);
  //     return null;
  //   }
  // }





  // mappingNotification(log: any, notifications: any[]): any {
  //   if (!log) return { config: { notifications } };  // fallback

  //   return {
  //     ...log,
  //     config: {
  //       ...(log.config || {}),   // safe spread
  //       notifications: notifications
  //     }
  //   };
  // }



  mappingNotification(log: any, notifications: any[]): any {
    // Extract providerIds as an array of numbers
    let providerIds: number[] = [];
    if (log?.config?.providerIds) {
      providerIds = log.config.providerIds
        .toString()
        .split(",")
        .map((id: string) => parseInt(id.trim(), 10))
        .filter((id: number) => !isNaN(id));
    }

    // Find full notification objects that match providerIds
    const matchedNotifications = notifications.filter(n =>
      providerIds.includes(n.consumer_id)
    );

    // Replace providerIds with full notification objects
    return {
      ...log,
      config: {
        ...log.config,
        providerIds: matchedNotifications   // <-- now array of objects
      }
    };
  }





  convertToArray(obj: any): { key: string; value: any[] }[] {
    return Object.keys(obj).map(k => ({
      key: k,
      value: obj[k]
    }));
  }



}
